import { FormControl, TextField } from "@mui/material";
import localize from "../../../common/localize";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import CreatedByText from "../../../components/common/CreatedByText";

export default function AddOrEditMeasurementUnit({ model, setModel }) {
  const handleChange = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div style={{ width: "100%" }}>
      <form className="w-full mt-2">
        <div className="flex flex-wrap mb-6">
          <FormControl required fullWidth>
            <TextField
              required
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              id="outlined-basic"
              name="Name"
              label={localize.name}
              variant="outlined"
              onChange={handleChange}
              value={model.Name}
            />
          </FormControl>
        </div>

        <div className="flex flex-wrap mb-6">
          <FormControl required fullWidth>
            <TextField
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              id="outlined-basic"
              name="Symbol"
              label={localize.symbol}
              variant="outlined"
              onChange={handleChange}
              value={model.Symbol}
            />
          </FormControl>
        </div>
      </form>

      <CreatedByText entity={model} />
    </div>
  );
}
